<template>
	<transition name="fade">
		<div class="modal" :class="{'in':show}" ref="modal">
			<div class="modal-dialog" :class="setSize">
				<div class="modal-content">
					<div class="modal-header">
						<button type="button" class="close" @click="close">
						<span aria-hidden="true">&times;</span>
					</button>
						<h4 v-if="!!header" class="modal-title">{{header}}</h4>
						<slot name="header"></slot>
					</div>
					<div class="modal-body">
						<slot name="body"></slot>
					</div>
					<div class="modal-footer">
						<slot name="footer"></slot>
					</div>
				</div>
			</div>
			<div class="modal-mask" @click="close"></div>
		</div>
	</transition>
</template>

<script>
	export default {
		props: {
			size: String,
			show: Boolean,
			header: String
		},
		data() {
			return {}
		},
		methods: {
			close() {
				this.$emit('close')
			}
		},
		computed: {
			setSize() {
				return this.size ? "modal-" + this.size : '';
			}
		}

	}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
	@import (reference) "../../assets/lib/css.less";
	.modal {
		&.in {
			opacity: 1;
			display: block;
		}
		.modal-content {
			.unbdr;
			.unbs;
		}
		.modal-full {
			width: 100%;
			margin: 0;
		}
		.modal-dialog {
			z-index: 3;
		}
		.modal-mask {
			position: fixed;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			z-index: 2;
			width: 100%;
			height: 100%;
			background-color: rgba(0, 0, 0, 0.5);
		}
	}
	/*trs*/
	
	.fade-enter-active,
	.fade-leave-active {
		transition: opacity .5s
	}
	
	.fade-enter,
	.fade-leave-active {
		opacity: 0
	}
</style>


// WEBPACK FOOTER //
// modal.vue?5e9da11f